import React, { useState, useEffect } from "react";
import Home from "./pages/TopNavBar/Home/Home";
import Register from "./pages/TopNavBar/Register/Register";
import Verification from './pages/Verification/Verification';
import { Routes, Route, Navigate, useLocation } from "react-router-dom";
import WebNavbar from "./components/Navbar/WebNavbar";
import AppNavbar from "./components/Navbar/AppNavbar";
import { AuthContext } from "./contexts/AuthContext";
import AdobeSampleSize from "./pages/LeftSideNav/UsefulLinks/AdobeSampleSize/AdobeSampleSize";
import AdobeCommunity from "./pages/LeftSideNav/UsefulLinks/AdobeCommunity/AdobeCommunity";
import AdobeCheatsheet from "./pages/LeftSideNav/UsefulLinks/AdobeCheatsheet/AdobeCheatsheet";
import AdobeKnowledgeRepo from "./pages/LeftSideNav/UsefulLinks/AdobeKnowledgeRepo/AdobeKnowledgeRepo";
import Footer from "./components/UI/Footer";
import ForgotPassword from "./pages/ForgotPassword/ForgotPassword";
import PrivacyNotice from "./pages/TopNavBar/PrivacyNotice";
import TermsOfService from "./pages/Footer/TermsOfService";
import ContactUs from "./pages/Footer/ContactUs";
import AboutUs from "./pages/TopNavBar/AboutUs";
import Dashboard from "./pages/LeftSideNav/Dashboard";
import EPM from "./pages/LeftSideNav/EPM";
import CookiePolicy from "./pages/Footer/CookiePolicy";
import Profile from "./pages/RightSideMenu/Profile";
import Company from "./pages/RightSideMenu/Organization";
import ManageUsers from "./pages/RightSideMenu/ManageUsers";
import Layout from "./components/Layout";
import AdobeIO from './pages/LeftSideNav/Setup/AdobeIO';
import NewIntegration from "./pages/LeftSideNav/Setup/AdobeIO/NewIntegration";
import EditIntegration from "./pages/LeftSideNav/Setup/AdobeIO/EditIntegration";
import Experience from './pages/LeftSideNav/Experiences';
import { useAuth0 } from "@auth0/auth0-react";
import EmailVerification from "./pages/ValidateEmailVerification/PostEmailVerification";
import ValidateEmailVerification from "./pages/ValidateEmailVerification/ValidateEmailVerification";
import Loader from "./components/UI/Loader/Loader";
import { ToastContainer } from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';
import BlockedUser from "./pages/BlockedUser/BlockedUser";
import LoginCheck from "./pages/LoginCheck/LoginCheck";
import { useUserContext } from "./contexts/UserContext";
import TealiumApiKey from "./pages/LeftSideNav/Setup/TealiumApiKey";
import NewTealiumIntegration from "./components/Tealium/TealiumApiKeys/NewIntegration";
import EditTealiumIntegration from "./components/Tealium/TealiumApiKeys/EditTealiumIntegration";
import { permission } from "./config/permission";
import TealiumAudienceStreamPage from "./pages/LeftSideNav/TealiumAudiences";
import NewTealiumAudienceStream from "./components/Tealium/TealiumAudienceStream/NewTealiumAudienceStream";
import { useIdleTimer } from 'react-idle-timer';
import ManageWorkspaces from "./pages/LeftSideNav/Setup/Workspaces/ManageWorkspaces";
import Login from "./pages/TopNavBar/Login/Login";
import Tasks from "./pages/LeftSideNav/Functions";
import TasksReport from "./pages/LeftSideNav/Functions/Report"
import SavedTasks from "./pages/LeftSideNav/Functions/SavedTasks";
import EditSavedTask from "./pages/LeftSideNav/Functions/EditSavedTask";
import AEMAdobeIO from "./pages/LeftSideNav/Setup/AEMAdobeIO/AEMAdobeIO";
import NewAEMAdobeIOIntegration from "./components/AEMAdobeIO/NewAEMAdobeIO";
import GlobalTemplate from "./pages/LeftSideNav/GlobalTemplates";
import FunctionPage from "./pages/LeftSideNav/GlobalFunctions";
import PermissionsPage from "./pages/LeftSideNav/Permissions";
import PermissionDetails from "./components/Permissions/PermissionDetails";
import OrgLevelsPage from "./pages/LeftSideNav/OrgLevels";
import OrgLevelDetails from "./components/OrgLevels/OrgLevelDetails";
import ProductsPage from "./pages/LeftSideNav/Products";
import UserManagementPage from "./pages/LeftSideNav/UserManagement";
import OrganizationsPage from "./pages/LeftSideNav/Organizations";
import AdminWorkspacesPage from "./pages/LeftSideNav/AdminWorkspaces";
import NotificationsPage from "./pages/LeftSideNav/Notifications";
import ManageContentfulIntegration from "./pages/LeftSideNav/Setup/Contentful";
import ContentfulIntegration from "./components/ContentfulIntegration/ContentfulIntegration";
import ReleasePage from "./pages/LeftSideNav/Release";
import Admin from "./pages/LeftSideNav/Admin";
import ManageCSP from "./pages/LeftSideNav/Admin/ManageCSP/ManageCSP";
import Setup from "./pages/LeftSideNav/Setup/Setup";
import { JoyrideProvider } from "./contexts/JoyrideContext";
import JoyrideApp from "./components/Joyride/JoyrideApp";
import Tutorials from "./pages/LeftSideNav/Tutorials/Tutorials";
import ContactUS from "./pages/LeftSideNav/ContactUS";
import { NotificationContextProvider } from "./contexts/NotificationContext";
import { useContentfulContext } from "./contexts/ContentfulContext";
import PlanPage from "./pages/LeftSideNav/Plan/PlanPage";
import OrgPlanMappingPage from "./pages/LeftSideNav/OrgPlanMapping/OrgPlanMappingPage";
import MyPlan from "./pages/RightSideMenu/MyPlan";
import AccessDenied from "./pages/AccessDenied/AccessDenied";
import { PreviewModeProvider } from "./contexts/PreviewModeContext";
import AddEditGithubIntegration from "./pages/LeftSideNav/Setup/Github/AddEditGithubIntegration";
import GithubIntegration from "./pages/LeftSideNav/Setup/Github/GithubIntegration";
import TaskConfig from "./pages/LeftSideNav/Functions/TaskConfig";
import PricingPage from "./pages/TopNavBar/Pricing/PricingPage";
import PaymentSuccess from "./pages/Payment/PaymentSuccess";
import PaymentFailed from "./pages/Payment/PaymentFailed";
import PaymentProcessing from "./pages/Payment/PaymentProcessing";
import TealiumDataLayerReport from "./pages/LeftSideNav/Functions/TealiumDataLayerReport/TealiumDataLayerReport";
import AdobeTargetActivitiesRevisionsData from "./pages/LeftSideNav/Functions/AdobeTargetActivitiesRevisionsData";
import ProductAnalyticsDashboard from "./components/Dashboard/ProductAnalyticsDashboard";
import NotFound from "./pages/NotFound/NotFound";
import NoInternet from "./pages/NoInternet/NoInternet";
import ErrorBoundary from "./components/ErrorBoundary/ErrorBoundary";
import useOnlineStatus from "./hooks/useOnlineStatus";
import AiAssistant from "./components/AiAssistant";

const { REACT_APP_INACTIVITY_TIMEOUT } = process.env;

function App() {
  const { isAuthenticated, user, isLoading, logout } = useAuth0();
  const isOnline = useOnlineStatus();
  const { loading, userData, checkPermission, setSelectedOrganization } = useUserContext();
  const { enums } = useContentfulContext();
  const { pathname } = useLocation()

  const [auth, setAuth] = useState({
    user_name: '',
    user_email: '',
    user_verification: false,
    user_loggedIn: false
  });

  useEffect(() => {
    setAuth({
      user_name: '',
      user_email: '',
      user_verification: false,
      user_loggedIn: window.localStorage.getItem('logged-in')
    });

    // Restore selected org from localStorage on reload
    const savedOrg = localStorage.getItem('selectedOrganization');
    if (savedOrg) {
      try {
        const org = JSON.parse(savedOrg);
        if (org && (!userData.selectedOrganization || userData.selectedOrganization.name !== org.name)) {
          setSelectedOrganization(org, false);
        }
      } catch (e) { /* ignore */ }
    }
  }, [])

  const selectedOrgLevel = userData?.selectedOrganization?.level;

  const onIdle = () => {
    if (isAuthenticated)
      logout({
        logoutParams: { returnTo: enums?.LOGOUT_REDIRECT_URL },
      });
  }

  useIdleTimer({
    onIdle,
    timeout: (parseInt(REACT_APP_INACTIVITY_TIMEOUT) || 30) * 60 * 1000,
  })

  if (isLoading && !isAuthenticated) return <Loader />
  if (!isOnline) return <NoInternet />

  return (
    <ErrorBoundary>
    <PreviewModeProvider>
      <JoyrideProvider>
        <AuthContext.Provider value={{ auth, setAuth }}>
          <ToastContainer />
          <NotificationContextProvider>
            {!isLoading ?
              ((isAuthenticated || (loading && (!userData?.user_metadata?.is_invited ? user?.email_verified : true))) ? (
                <AppNavbar />
              ) : pathname !== "/login" ? (
                <WebNavbar />
              ) : null) : null
            }
            <div id="alert"></div>
            {
              isAuthenticated && !loading && <JoyrideApp isAuthenticated={isAuthenticated && !!user?.email_verified} />
            }
            <Routes>
              {/* ── Auth0 callback routes — always accessible ───────────────────────
                  These are called by Auth0 AFTER an async operation (login, email
                  verification, block). isAuthenticated may already be true when
                  Auth0 redirects here, so they must live outside auth guards. */}
              <Route path="/auth/login-check" element={<LoginCheck />} />
              <Route path="/auth/validate-email" element={<ValidateEmailVerification />} />
              <Route path="/auth/email-verification" element={<EmailVerification />} />
              <Route path="/auth/blocked-user" element={<BlockedUser />} />

              {/* ── Always-accessible public pages ─────────────────────────────── */}
              <Route path="/privacy-notice" element={<PrivacyNotice />} />
              <Route path="/terms-of-service" element={<TermsOfService />} />
              <Route path="/cookie-policy" element={<CookiePolicy />} />
              <Route path="/about" element={<AboutUs />} />

              {/* ── Unauthenticated-only routes ─────────────────────────────────── */}
              {!isAuthenticated && (
                <>
                  <Route path="/" element={<Home />} />
                  <Route path="/login" element={<Login />} />
                  <Route path="/contact-us" element={<ContactUs />} />
                  {/* User-initiated auth flows — only valid before login */}
                  <Route path="/auth/register" element={<Register />} />
                  <Route path="/auth/forgot-password" element={<ForgotPassword />} />
                  <Route path="/auth/verification" element={<Verification />} />
                  <Route path="*" element={<NotFound />} />
                </>
              )}

              {/* ── Authenticated routes ────────────────────────────────────────── */}
              {isAuthenticated && !loading && (
                <>
                  <Route path="/" element={<Navigate to="/dashboard" replace />} />
                  <Route path="/dashboard" element={<Layout />} >
                    <Route path="/dashboard/" element={<Dashboard />} />
                  </Route>

                  <Route path="/access-denied" element={<AccessDenied />} />
                  <Route path="/pricing" element={<PricingPage />} />
                  <Route path="/payment/success" element={<PaymentSuccess />} />
                  <Route path="/payment/failed" element={<PaymentFailed />} />
                  <Route path="/payment/processing" element={<PaymentProcessing />} />

                <Route element={<Layout />}>
                  {(selectedOrgLevel?.route_permission['saved-tasks'] == true || selectedOrgLevel?.route_permission['one-off-tasks'] == true) && (
                    <>
                      <Route path="/functions" element={<Tasks />} />
                      <Route path="/functions/one-off-tasks/:id" element={<TasksReport />} />
                      <Route path="/functions/task-config/:id" element={<TaskConfig />} />
                      <Route path="/functions/one-off-tasks/:id/:saved_task_id" element={<EditSavedTask />} />
                      <Route path="/functions/saved-tasks" element={<SavedTasks />} />
                      <Route path="/task/tealium-data-layer/report/:id" element={<TealiumDataLayerReport />} />
                      <Route path="/task/adobe-target-revisions/:id" element={<AdobeTargetActivitiesRevisionsData />} />
                    </>
                  )}
                </Route>

                  <Route path="/admin" element={<Layout />} >
                    {selectedOrgLevel?.route_permission["admin"] == true && (
                      <>
                        <Route path="/admin" element={<Admin />} />
                        <Route path="/admin/csp" element={<ManageCSP />} />
                      </>
                    )}

                    {selectedOrgLevel?.route_permission["manage-global-templates"] == true && (
                      <Route path="/admin/global-template/*" element={<GlobalTemplate />} />
                    )}

                    {selectedOrgLevel?.route_permission["user-management"] == true && (
                      <Route path="/admin/user-management" element={<UserManagementPage />} />
                    )}

                    {selectedOrgLevel?.route_permission["organization"] == true && (
                      <Route path="/admin/organizations" element={<OrganizationsPage />} />
                    )}

                    {(selectedOrgLevel?.route_permission["organization"] == true || selectedOrgLevel?.route_permission["admin"] == true || selectedOrgLevel?.route_permission["workspaces"] == true) && (
                      <>
                        <Route path="/admin/workspaces" element={<AdminWorkspacesPage />} />
                        <Route path="/admin/openrouter-workspaces" element={<AdminWorkspacesPage />} />
                      </>
                    )}

                    {selectedOrgLevel?.route_permission["functions"] == true && (
                      <Route path="/admin/functions" element={<FunctionPage />} />
                    )}
                    {selectedOrgLevel?.route_permission["permissions"] == true && (
                      <>
                        <Route path="/admin/permissions" element={<PermissionsPage />} />
                        <Route path="/admin/permissions/:id" element={<PermissionDetails />} />
                      </>
                    )}
                    {selectedOrgLevel?.route_permission["org-levels"] == true && (
                      <>
                        <Route path="/admin/org-level" element={<OrgLevelsPage />} />
                        <Route path="/admin/org-level/:id" element={<OrgLevelDetails />} />
                      </>
                    )}
                    {selectedOrgLevel?.route_permission["manage-plan"] == true && (
                      <>
                        <Route path="/admin/plan/" element={<PlanPage />} />
                      </>
                    )}
                    {selectedOrgLevel?.route_permission["manage-org-plan-mapping"] == true && (
                      <>
                        <Route path="/admin/org-plan-mapping/" element={<OrgPlanMappingPage />} />
                      </>
                    )}
                    {selectedOrgLevel?.route_permission["notifications"] == true && (
                      <>
                        <Route path="/admin/notifications" element={<NotificationsPage />} />
                      </>
                    )}
                    {selectedOrgLevel?.route_permission["release"] == true && (
                      <>
                        <Route path="/admin/release" element={<ReleasePage />} />
                      </>
                    )}
                    {selectedOrgLevel?.route_permission["products"] == true && (
                      <Route path="/admin/products" element={<ProductsPage />} />
                    )}
                    {(selectedOrgLevel?.route_permission["product-analytics"] == true || selectedOrgLevel?.route_permission["admin"] == true) && (
                      <Route path="/admin/product-analytics" element={<ProductAnalyticsDashboard />} />
                    )}
                  </Route>

                  <Route element={<Layout />}>
                    <Route path="/epm/*" element={<EPM />} />
                    <Route path="/experience/*/:id?" element={<Experience selectedOrgLevel={selectedOrgLevel} />} />
                  </Route>
                  <Route path="/settings" element={<Layout />}>
                    <Route path="/settings/profile" element={<Profile />} />
                    <Route path="/settings/organisation" element={<Company />} />
                    <Route path="/settings/manage-users" element={<ManageUsers />} />
                    <Route path="/settings/my-plan" element={<MyPlan />} />
                  </Route>
                  {selectedOrgLevel?.route_permission['setup'] == true && (
                    <Route path="/setup" element={<Layout />}>

                      <Route path="/setup" element={<Setup />} />

                      {selectedOrgLevel?.route_permission['adobe-io-integrations'] == true && <>
                        <Route path="/setup/adobeIO-integrations" element={<AdobeIO />} />
                        {checkPermission(permission.CREATE_ADOBE_IO) && <Route path="/setup/new-integration" element={<NewIntegration />} />}
                        <Route path="/setup/integration/edit/:id" element={<EditIntegration />} />
                      </>}
                      {selectedOrgLevel?.route_permission['tealium-api-keys'] == true && <>
                        <Route path="/setup/tealium-api-key-integrations" element={<TealiumApiKey />} />
                        {checkPermission(permission.CREATE_TEALIUM) && <Route path="/setup/tealium-new-integration" element={<NewTealiumIntegration />} />}
                        <Route path="/setup/tealium/edit/:id" element={<EditTealiumIntegration />} />
                      </>}
                      {selectedOrgLevel?.route_permission['tealium-api-keys'] == true && <>
                        <Route path="/setup/aem-adobe-io" element={<AEMAdobeIO />} />
                        {checkPermission(permission.CREATE_TEALIUM) && <Route path="/setup/new-aem-adobe-io" element={<NewAEMAdobeIOIntegration />} />}
                        <Route path="/setup/new-aem-adobe-io/:id" element={<NewAEMAdobeIOIntegration />} />
                      </>}
                      {selectedOrgLevel?.route_permission['workspaces'] == true && <>
                        <Route path="/setup/workspaces" element={<ManageWorkspaces />} />
                      </>}
                      {selectedOrgLevel?.route_permission['contentful-integrations'] == true && <>
                        <Route path="/setup/contentful-integrations" element={<ManageContentfulIntegration />} />
                        <Route path="/setup/edit-contentful-integration/:id" element={<ContentfulIntegration />} />
                        <Route path="/setup/add-contentful-integration" element={<ContentfulIntegration />} />
                      </>}

                      {selectedOrgLevel?.route_permission['github-integrations'] == true && <>
                        <Route path="/setup/github-integrations" element={<GithubIntegration />} />
                        <Route path="/setup/edit-github-integration/:id" element={<AddEditGithubIntegration />} />
                        <Route path="/setup/add-github-integration" element={<AddEditGithubIntegration />} />
                      </>}
                    </Route>)}

                  {selectedOrgLevel?.route_permission['audiences'] == true && (
                    <Route path="/audiences" element={<Layout />}>
                      {selectedOrgLevel?.route_permission['tealium-audience-stream'] == true && <>
                        <Route path="/audiences/tealium-audience-stream" element={<TealiumAudienceStreamPage />} />
                        {checkPermission(permission.CREATE_ADOBE_IO) &&
                          (<Route path="/audiences/new-tealium-audience-stream" element={<NewTealiumAudienceStream />} />)}
                        {/* <Route path="/audiences/tealium-audience-stream/edit/:id" element={<EditIntegration />} /> */}
                      </>}
                      {selectedOrgLevel?.route_permission['adobe-target-audiences'] == true && <>
                        {checkPermission(permission.CREATE_TEALIUM) && (
                          <Route path="/audiences/new-adobe-target-audiences" element={<NewTealiumIntegration />} />)}
                        <Route path="/audiences/adobe-target-audiences/edit/:id" element={<EditTealiumIntegration />} />
                      </>}
                    </Route>)}

                  <Route path="/useful-links/adobe-knowledge-repo" element={<AdobeKnowledgeRepo />} />
                  <Route path="/useful-links/adobe-sample-size-calculator" element={<AdobeSampleSize />} />
                  <Route path="/useful-links/adobe-community" element={<AdobeCommunity />} />
                  <Route path="/useful-links/adobe-cheatsheet" element={<AdobeCheatsheet />} />
                  <Route path="/tutorials" element={<Tutorials />} />

                  <Route element={<Layout />}>
                    <Route path="/contact-us" element={<ContactUS />} />
                  </Route>

                  <Route path="*" element={<NotFound />} />
                </>
              )}

              {/* While user data is still loading post-login, show a spinner
                  so the wildcard doesn't fire a false 404 */}
              {isAuthenticated && loading && (
                <Route path="*" element={<Loader />} />
              )}
            </Routes>
            {(!isAuthenticated && (pathname !== '/login')) ? <Footer /> : null}
            {isAuthenticated && !loading && <AiAssistant />}
          </NotificationContextProvider>
        </AuthContext.Provider>
      </JoyrideProvider>
    </PreviewModeProvider>
    </ErrorBoundary>
  );
}

export default App;
